export default __webpack_public_path__ + "static/media/Arrow_down.9432dedd.svg";